// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-bar[data-v-58405699]{position:relative;background:#333;padding:20px 0;clear:both;margin-top:30px}.footer-bar .footerBox[data-v-58405699]{width:1200px;margin:0 auto;color:#d2d2d2;font-size:16px;line-height:30px}", ""]);
// Exports
module.exports = exports;
